import { render } from "./BaseIconText.vue?vue&type=template&id=7d5e3be7&scoped=true"
import script from "./BaseIconText.vue?vue&type=script&lang=js"
export * from "./BaseIconText.vue?vue&type=script&lang=js"

import "./BaseIconText.vue?vue&type=style&index=0&id=7d5e3be7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5e3be7"],['__file',"src/components/BaseIconText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d5e3be7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d5e3be7', __exports__)) {
    api.reload('7d5e3be7', __exports__)
  }
  
  module.hot.accept("./BaseIconText.vue?vue&type=template&id=7d5e3be7&scoped=true", () => {
    api.rerender('7d5e3be7', render)
  })

}


export default __exports__